import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { CellEditArgs, DataStateChangeEventArgs, EditSettingsModel, FilterSettingsModel, GridComponent, PageSettingsModel, SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GlobalComponent } from 'src/app/global/global.component';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { columnWidth } from '../employee/employee.model';
import { HttpBackend, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { DateService } from 'src/app/date.service';
import { IMyDpOptions } from 'mydatepicker';
import { DatePipe } from '@angular/common';
import { ConsultationServices } from '../consultation-services/consultation-services.service';
import { ClientHttpService } from '../client-parent/client-parent.service';
import { Router } from '@angular/router';
import { GetEngagement, LinkTickets, SaveEngagement, Tickets } from './engagement.modal';
import { EngagementService } from './engagement.service';
import { CommonApiService } from 'src/app/commonapiservice';
import { TicketViewService } from '../ticket/ticket-view/ticket-view.service';
import { GetTicketsBO } from '../ticket/ticket.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-engagement',
  templateUrl: './engagement.component.html',
  styleUrls: ['./engagement.component.scss']
})
export class EngagementComponent implements OnInit {
  public pageSizes: number[] = [10, 15, 20, 50, 100, 250];
  initialPage: PageSettingsModel;
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    disableSince: { year: new Date().getFullYear(), month: new Date().getMonth() + 1, day: new Date().getDate() + 1 },
    showClearDateBtn: true,
    editableDateField: true
  };
  datetimeformat: object;
  public editSettings: EditSettingsModel;
  filterOptions: FilterSettingsModel;
  public EngagementGrid: Observable<DataStateChangeEventArgs>;
  private onDestroy$: Subject<void> = new Subject<void>();
  @ViewChild('engagementgrid') public engagementgrid: GridComponent;
  @ViewChild('grid') public grid: GridComponent;
  public GridDataList: Observable<DataStateChangeEventArgs>;
  FilterStartDate: any = "";
  FilterEndDate: any = "";
  StartDate: any = "";
  EndDate: any = "";
  EBO: GetEngagement = new GetEngagement();
  EngagementData: SaveEngagement = new SaveEngagement();
  SaveTickets: Tickets = new Tickets();
  arraycol: any = [];
  viewEngagement: boolean = false;
  tickets: any = []
  TicketStatus: any = [];
  TicketPriority: any = [];
  TicketType: any = [];
  EmployeeDropdown: any = [];
  TotalHourse: any;
  ListSendBO = new GetTicketsBO();
  TicketsList: any;
  LinkTicket: LinkTickets = new LinkTickets();
  mappedId: string;
  ChannelNameList:{ Key: string, Value: string }[];
  QueueNameList:string[];
  CustomerTypeList:string[];
  DirectionList = ['INBOUND','OUTBOUND'];
  EngagementDropdown: any = [];
  ticketsForm: FormGroup;
  Engagementlogid : string;
  openengagement :boolean=false;
  AllClientDropDownListwithStatus: any;
  messages ;
  private httpNoInterceptor: HttpClient;
  audioUrl ;
  @ViewChild('audioRef') audioRef!: ElementRef<HTMLAudioElement>;
  @Input() clientTab: string;
  ValidationDate: string;
  constructor(public datepipe: DatePipe, public dateservice: DateService, public global: GlobalComponent, private toastrService: ToastrService
    , public CSService: ConsultationServices, public ClientService: ClientHttpService, public service: TicketViewService,
    public router: Router, public engagementservice: EngagementService, public CommonAPI: CommonApiService ,private formBuilder: FormBuilder,private http: HttpClient, handler: HttpBackend
  ) {
     this.httpNoInterceptor = new HttpClient(handler);  
    this.EngagementGrid = this.engagementservice;
      this.ticketsForm = this.formBuilder.group({
          id: ['00000000-0000-0000-0000-000000000000'],
          title: ['', Validators.required],
          description: ['', Validators.required],
          assignee: ['', Validators.required],
          tickettype: ['', Validators.required],
          status: ['', Validators.required],
          priority: [''],
    
        });
      }
  
  ngOnInit(): void {
    if (this.global.globalAgencyId == null ||
      this.global.globalAgencyId == undefined ||
      this.global.globalAgencyId == "" ||
      this.global.globalAgencyId == "00000000-0000-0000-0000-000000000000") {
      return;
    }
    this.datetimeformat = {
      type: "datetime",
      format: "MM/dd/yyyy h:mm:ss a",
    };
    this.filterOptions = { type: 'Menu' };
    this.initialPage = { currentPage: 1, totalRecordsCount: 0, pageCount: 10, pageSize: this.pageSizes[0], pageSizes: this.pageSizes };
    this.editSettings = { allowEditing: false, mode: 'Normal', allowEditOnDblClick: true }
    this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.ChannelNameList = [{ Key: "CHAT", Value: "CHAT" },
                            { Key: "VOIP", Value: "VOIP" },
                            { Key: "PSTN", Value: "PSTN" },
                           ]
    this.getpermission();
    this.getEngagementsListFilter();
    this.getEmployeeDropdown();
    this.getTicketPriority();
    this.getTicketStatus();
    this.getTicketType();
    this.getTickets();
    this.getFilterList();
    this.getEngagementdd();
    this.getAllClient();

  }
  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.toastrService.success("Copied to clipboard")
    }).catch(err => {
      console.error('Could not copy text: ', err);
    });
  }
    fp:any;
  getpermission() {
     let params = new URLSearchParams();
      params.append("pagecode", "ENGAGEMENT");    
     let url = "api/FunctionPermission/getfunctionpermissionemployee?";
     this.CommonAPI.GetFunctionwithResponseTypeJson(params, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
       if (data != null) {
         this.fp = data;
       }
       else {
         this.fp = null;
       }
     },
       (err: HttpErrorResponse) => {
         this.fp = null;
       })
   }

  getEngagementsListFilter() {
    let SDate = this.FilterStartDate;
    let EDate = this.FilterEndDate;
    this.EBO.startDate = (SDate != null && SDate != undefined && SDate != "") ? this.global.getDateTimeStringWithOffset(SDate) : null
    this.EBO.endDate = (EDate != null && EDate != undefined && EDate != "") ? this.global.getDateTimeStringWithOffset(EDate) : null
    if(this.EBO.customerType !== 'CLIENT')
    {
      this.EBO.customerId = null;
    }
    if(this.clientTab == 'clienttab')
    {
      this.EBO.customerType = 'CLIENT';
      this.EBO.customerId = this.global.clientId
    }
    this.engagementservice.outputValues(this.EBO)
    let count = 0;
    this.EngagementGrid.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.EngagementData = data.result;
      if (this.global.globalAgencyId != 0) {
        if (data != null && data.result?.length > 15) {
          this.engagementgrid.height = '500';
        }
        else {
          this.engagementgrid.height = 'auto';
        }
      }
    }
    )
  }
  formatDuration(duration: any): string {
    if (!duration || !duration.value) return "0 sec";

    const totalSeconds = Math.floor(duration.value.totalSeconds);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${hours}hr ${minutes}mins ${seconds}sec`;
  }

  public dataStateChange(state): void {
    let type: String = (state.action.requestType).toString();
    this.EBO.currentpageno = this.engagementgrid.pagerModule.pagerObj.currentPage;
    this.EBO.pageitem = this.engagementgrid.pagerModule.pagerObj.pageSize;
    if (state.action.requestType != "filterchoicerequest") {
      if ((state.sorted || [])?.length) {
        this.EBO.orderColumn = state.sorted[0].name;
        this.EBO.orderType = state.sorted[0].direction === 'descending' ? 'DESC' : 'ASC';
      }
    }
    if (type == "filtering" && state.action.action != "clearFilter") {
      this.EBO.currentpageno = 1;
      this.EBO.pageitem = 10;
      if (this.EBO.type == "date") {
        this.EBO.value = (new Date(new Date(state.action.currentFilterObject.value).toDateString() + " " + "00:00:00" + " " + "GMT").toISOString()).replace("Z", "");
      }
      else {
        this.EBO.value = state.action.currentFilterObject.value;
      }
      this.EBO.field = state.action.currentFilterObject.field
      if (state.action.currentFilterObject.field == "isClientSign") {
        this.EBO.value = this.EBO.value == 'Yes' ? 'true' : 'false';
        this.EBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "isEmployeeSign") {
        this.EBO.value = this.EBO.value == 'Yes' ? 'true' : 'false';
        this.EBO.type = "boolean";
      }
      if (state.action.currentFilterObject.field == "timesheetStatusLid") {
        this.EBO.field = "timesheetStatus"
        this.EBO.type = "string";
      }
      if (state.action.currentFilterObject.field == "totalHours") {
        this.EBO.value = this.EBO.value.toString();
      }
      // if (state.action.currentFilterObject.field == "dailyAuthorizedhours") {
      //   this.EBO.value = this.EBO.value.toString();
      // }
      this.EBO.operator = state.action.currentFilterObject.operator;
    }
    if (state.action.requestType == "filtering" && state.action.action == "clearFilter") {
      this.EBO.currentpageno = 1;
      this.EBO.pageitem = 10;
      this.EBO.operator = "contains"
      this.EBO.type = "string";
      this.EBO.value = "";
      this.EBO.field = "AgentName";
      this.EBO.orderColumn = "startTime";
      this.EBO.orderType = 'desc';
    }
    if (state.action.requestType != "refresh") {
      this.getEngagementsListFilter();
    }
  }

  public onActionComplete(args) {
    if (args.requestType == "columnstate") {
      let hidearr = [];
      let showarr = [];
      this.engagementgrid.columns.forEach(element => {
        if (element.visible == false && element.headerText != "Actions" && element.headerText != "") {
          hidearr.push(element.headerText);
        }
        if (element.visible == true && element.headerText != "Actions" && element.headerText != "") {
          showarr.push(element.headerText);
        }
      })
      var count = 0;
      var count1 = 0;
      if (args.columns?.length > 0) {
        if (this.arraycol?.length > 0) {
          this.arraycol[0].EVV_Timesheet.ShowColumns.forEach(old => {
            showarr.forEach(element => {
              if (old == element) {
                count1 = count1 + 1;
              }
            });
          });
          this.arraycol[0].EVV_Timesheet.HideColumns.forEach(old => {
            hidearr.forEach(element => {
              if (old == element) {
                count = count + 1;
              }
            });
          });
          if (this.arraycol[0].EVV_Timesheet.ShowColumns?.length != count1 || this.arraycol[0].EVV_Timesheet.HideColumns?.length != count) {
            this.arraycol[0].EVV_Timesheet.ShowColumns = showarr;
            this.arraycol[0].EVV_Timesheet.HideColumns = hidearr;
            //this.SaveColumnwidth();
          }
        }

      }
    }
    if (args.requestType == "filterafteropen") {
      this.EBO.type = args.columnType;
    }
  }

  EditEngagement(event, data) {
    this.EngagementData = data;
    this.EngagementData.duration = data.formattedDuration;
    this.EngagementData.startTime = this.datepipe.transform(this.EngagementData.startTime, "MM/dd/yyyy h:mm:ss a")
    this.EngagementData.endTime = this.datepipe.transform(this.EngagementData.endTime, "MM/dd/yyyy h:mm:ss a");
    this.SaveTickets.engagementLogsId = data.id;
    this.Engagementlogid = data.id;
    this.ListSendBO.id = data.id;
    this.openengagement = true;
    this.LinkTicket.engagementLogId = data.id;
    this.GetTicketsList();
  }
  getDeleteId(event, data) {
  }
  show() {
    this.engagementgrid.columnChooserModule.openColumnChooser();
  }
  newdates(event, type, name) {
    if (type == "inputchange") {
      if (name == 'StartDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterStartDate = val1;
          this.clearEndTimeValidation();

        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.inputFeildchange(event);
        if (val != undefined) {
          let val1 = this.dateservice.inputFeildchange(event);
          this.FilterEndDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }

    if (type == "datechanged") {
      if (name == 'StartDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterStartDate = val1;
          var StartDate = new Date(this.FilterStartDate);
          let setDate = StartDate.setDate(StartDate.getDate() + 365);
          this.ValidationDate = this.datepipe.transform(setDate, "MM/dd/yyyy");
          this.clearEndTimeValidation();
        }
      }
      if (name == 'EndDate') {
        let val = this.dateservice.Datechange(event);
        if (val != undefined) {
          let val1 = this.dateservice.Datechange(event);
          this.FilterEndDate = val1;
          this.clearEndTimeValidation();
        }
      }
    }
  }
    clearEndTimeValidation() {
    if (this.FilterStartDate != null && this.FilterStartDate != undefined && this.FilterStartDate != '' &&
      this.FilterEndDate != null && this.FilterEndDate != undefined && this.FilterEndDate != '') {
      let EndDate = this.datepipe.transform(this.FilterEndDate, "MM/dd/yyyy");
      if (new Date(EndDate).getTime() > new Date(this.ValidationDate).getTime()) {
        this.toastrService.error("Date range should not be greater than 1 year");
        setTimeout(() => {
          this.toastrService.clear();
        }, 3000);
        this.FilterEndDate = null;
      }
      if (this.FilterEndDate != null && this.FilterEndDate != undefined && this.FilterEndDate != '') {
        if (new Date(this.FilterStartDate).getTime() > new Date(this.FilterEndDate).getTime()) {
          this.FilterEndDate = null;
          this.toastrService.error("end time should greater than start time");
          setTimeout(() => {
            this.toastrService.clear();
          }, 3000);
          return;
        }
      }
    }

  }
  clearengagement() {
    this.EBO.direction ='';
    this.EBO.channelName = '';
    this.EBO.queueName = '';
    this.EBO.engagementIds = [];
    this.openengagement = false;
    this.EBO.customerType = null;
    this.FilterStartDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.FilterEndDate = (new Date().getMonth() + 1) + '/' + new Date().getDate() + '/' + new Date().getFullYear();
    this.getEngagementsListFilter();
  }
  cancel() {
    this.viewEngagement = false;
  }
  getTicketStatus() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'TICKETSTATUS');
    this.CommonAPI.getDropDownList("TICKETSTATUS", params, url, "LovDropDown").then(
      (data: any) => {
        this.TicketStatus = data;
      },
      (err) => { }
    );
  }
  getTicketPriority() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'TICKETPRIORITY');
    this.CommonAPI.getDropDownList("TICKETPRIORITY", params, url, "LovDropDown").then(
      (data: any) => {
        this.TicketPriority = data;
      },
      (err) => { }
    );
  }
  getTicketType() {
    let url = "api/LOV/getLovDropDown?";
    let params = new URLSearchParams();
    params.append("ListCode", 'TICKETTYPE');
    this.CommonAPI.getDropDownList("TICKETTYPE", params, url, "LovDropDown").then(
      (data: any) => {
        this.TicketType = data;
      },
      (err) => { }
    );
  }

  getEmployeeDropdown() {
    let myParams = new URLSearchParams();
    // myParams.append("LocationId", this.locationId.toString());
    let url = "api/Employee/employeeDropDown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EmployeeDropdown = data;
      });
  }

  getTickets() {
    let myParams = new URLSearchParams();
    let url = "api/Ticket/TicketsDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.tickets = data;
      });
  }
  createTickets(event) {
    let url;
    url = "api/Ticket/SaveTicket";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.SaveTickets, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
     if(event =='create')
      this.toastrService.success("Ticket Added Successfully");
    else
       this.toastrService.success("Ticket Updated Successfully")
      this.GetTicketsList();
      this.getTickets();
      document.getElementById('openticket').click();
    },
      (err: any) => {
        this.toastrService.error(err)
        setTimeout(() => {
          this.toastrService.clear()
        }, 4000);
      })

  }
  GetTicketsList() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.ListSendBO.id)
    let url;
    url = "api/EngagementLogsTicketsMapping/GetMappedTicketsForEngagementLog?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.TicketsList = data;
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  selectedItem(data) {
    this.mappedId = data.mappedId;

  }
  DeleteTickets() {
    let myParams = new URLSearchParams();
    myParams.append("Id", this.mappedId)
    let url;
    url = "api/EngagementLogsTicketsMapping/DeleteEngagementLogTicketMapping?";
    this.CommonAPI.saveorUpdateFunctionwithParams(myParams, url).pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
      this.GetTicketsList();
      document.getElementById('OpenDeletetickets').click();
    },
      (err: any) => {
        this.toastrService.error(err);
      })
  }
  LinkTicketsList() {
    let url;
    url = "api/EngagementLogsTicketsMapping/MapTicketstoEngagementLog";
    this.CommonAPI.saveorUpdateFunctionwithResponseTypeJson(this.LinkTicket, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
      this.toastrService.success("Ticket Linked Successfully");
      this.GetTicketsList();
      document.getElementById('openlinkticket').click();
      this.LinkTicket.ticketIds = [];
    },
      (err: any) => {
        this.toastrService.error(err);
      })

  }

  getFilterList(){
    this.engagementservice.getFilterList().pipe().subscribe((data)=>{
      console.log(data);
      // this.ChannelNameList = data.channelName;
      this.QueueNameList = data.queueName;
      this.CustomerTypeList = data.customerTypeList;
 
    })

  }
  getEngagementdd() {
    let myParams = new URLSearchParams();
    let url = "api/EngagementLogs/EngagementDropdown?";
    this.CommonAPI
      .GetFunctionwithResponseTypeJson(myParams, url)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((data: any) => {
        data.forEach((element) => {
          element.Value = element.Value;
          element.Key = element.Key.toString();
        });
        this.EngagementDropdown = data;
      });

  }
  EditTicket(data)
{
  this.SaveTickets = data;
}
createTicket(){
  this.SaveTickets = new Tickets();
  this.SaveTickets.engagementLogsId = this.Engagementlogid; 
  document.getElementById('openticket').click();
}
getAllClient() {
    let param = new URLSearchParams();

    let locId;
    if (this.global.globalLocationId != null && this.global.globalLocationId != ''
      && this.global.globalLocationId != undefined) {
      locId = parseInt(this.global.globalLocationId);
    }
    else {
      locId = "00000000-0000-0000-0000-000000000000";
    }
    param.append("LocationId", locId);
    let url = "api/Client/GetAllClientsDropDownbyAgency?"
    this.CommonAPI.GetFunctionwithResponseTypeJson(param, url).pipe(takeUntil(this.onDestroy$)).subscribe((data: any[]) => {
     this.AllClientDropDownListwithStatus = JSON.parse(JSON.stringify(data));
      this.AllClientDropDownListwithStatus.forEach(record => {
          record.Key = record.id.toString();
          record.Value = record.names + " (" + record.status + ")";
          
          if (record.medicaid) {
            record.Value += " (" + record.medicaid + ")";
          }
        });                  
    })
  }
 getmedia(engagementid: string) {
  const url = 'api/EngagementLogs/GetRecordingStreamingURL?';
  const params = new URLSearchParams();
  params.append('EngagementId', engagementid);

  this.CommonAPI.GetFunctionwithResponseTypeJson(params, url)
    .pipe(takeUntil(this.onDestroy$))
    .subscribe((data: any) => {
      console.log(data);
      if (data?.fileExtention === '.txt') {
        this.loadChatHistory(data?.recording_Url);
      }
      else if(data?.fileExtention === ".mp3"){
          this.loadCallRecording(data?.recording_Url);
      }
    },(error)=>{
      this.toastrService.error(error)
    });
}

async loadChatHistory(blobUrl: string) {
  try {
    const data = await new Promise<string>((resolve, reject) => {
      this.httpNoInterceptor
        .get(blobUrl, { responseType: 'text' })
        .subscribe(resolve, reject);
    });

    try {
      this.messages = JSON.parse(data);
    } catch {
      this.messages = data;
    }

    document.getElementById('showChathistory')?.click();
  } catch (error) {
    this.toastrService.error(error)
    console.error('Error loading chat history:', error);
  }
}

loadCallRecording(url){
  this.audioUrl = url;
  document.getElementById('showCallhistory')?.click();

}
stopAudio(){
  this.audioRef?.nativeElement?.pause();
}


}